import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Severity} from 'smag-commons/dto/msg';
import {MatSelectChange} from '@angular/material/select';

@Component({
    selector: 'app-severity-selector',
    templateUrl: './severity-selector.component.html',
    styleUrls: ['./severity-selector.component.scss']
})
export class SeveritySelectorComponent implements OnInit {

    private selectedSeverities: Severity[];

    @Input() severities: Severity[];
    @Output() severitiesChange: EventEmitter<Severity[]> = new EventEmitter<Severity[]>();

    // exported in HTML
    Severity = Severity;

    constructor() {
        this.selectedSeverities = [];
    }

    ngOnInit() {
        this.selectedSeverities = this.severities;
    }

    severityEnabled(severity: Severity): boolean {
        return !this.selectedSeverities.includes(severity) || this.selectedSeverities.length > 1;
    }

    onSelectSeverities(event: MatSelectChange) {
        this.selectedSeverities = event.value as Severity[];
        this.severitiesChange.emit(this.selectedSeverities);
    }
}
